import { render, staticRenderFns } from "./com_confirm_default.vue?vue&type=template&id=2f7f8cc1"
import script from "./com_confirm_default.vue?vue&type=script&lang=js"
export * from "./com_confirm_default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports